import { AccessLevel, KrakendCollection, PagedResults } from "../models/generics";
import { LoaderMetadata, MetaLoaderListDTO, Rag, RagConfigs, RagListDTO, RagLoader } from "../models/LLM";
import client from "./axios";

const llmKrakendUrl = `${window.__env.KRAKEND_URL}/v1/llm`;

interface LoaderTestInfo {
  name: string;
  config: Record<string, any>;
}

type LoaderChunksRequestBody = LoaderTestInfo & {
  piece_index?: number;
  splittingConf?: Record<string, any>;
}

export interface ChunkMetadata {
  chunk: string;
  chunk_index: number;
  total_chunks: number;
}

interface TestLoaderResponse {
  is_working: boolean;
  error: string;
}

interface InvokeBody {
  context: Record<string, any>;
  input: { question: string };
  thread_id: string;
}
// type RetrieveBody = Pick<InvokeBody, 'context' | 'input'>;

interface InvokeReponse {
  question: string;
  answer: {
    id: string,
    content: string,
    type: string,
  }
}

export interface EmbedBody {
  jobId: string;
  ragId: number;
  loaderId: number;
  context: Record<string, any>;
  loader: LoaderTestInfo;
  splittingConf: any;
  accessLevel: AccessLevel;
  organizationId: string;
  ownerId: string;
}

export interface LlmModel {
  details: {
    families: string[];
    family: string;
    format: string;
    parameter_size: string;
    parent_model: string;
    quantization_level: string;
  },
  digest: string;
  model: string;
  modified_at: string;
  name: string;
  size: number;
}

export const Llm = {
  // TODO improve response -------↓
  getModels: () => client.get<{ models: LlmModel[] }>(`${llmKrakendUrl}/ollama/models`),
  pullModels: (model: any) => client.post(`${llmKrakendUrl}/ollama/pull-model`, model),
  getRagsContextConfigs: () => client.get<RagConfigs>(`${llmKrakendUrl}/rags/context-configs`),
  createRag: (rag: RagListDTO) => client.post<RagListDTO>(`${llmKrakendUrl}/rags`, rag),
  getRags: (params?: URLSearchParams) => client.get<PagedResults<RagListDTO> | KrakendCollection<RagListDTO>>(`${llmKrakendUrl}/rags`, { params }),
  getRag: (id: string) => client.get<Rag>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}`),
  editRag: (rag: RagListDTO) => client.put<RagListDTO>(`${window.__env.EVENT_GATEWAY_URL}/rag/${rag.id}`, rag),
  updateRagContext: (id: string, context: Record<string, any>) => client.put<Rag>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}/context`, context),
  deleteRag: (id: string) => client.delete(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}`),
  invokeRag: (id: string, body: InvokeBody) => client.post<InvokeReponse>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}/invoke`, body),
  // retrieve: (id: string, body: RetrieveBody) => client.post<InvokeReponse>(`${window.__env.EVENT_GATEWAY_URL}/rag/${id}/retrieve`, body),
  embedRagLoader: (body: EmbedBody) => client.post(`${window.__env.EVENT_GATEWAY_URL}/rag/${body.ragId}/embed`, body),
  getLoaders: (params?: URLSearchParams) => client.get<PagedResults<RagLoader> | KrakendCollection<RagLoader>>(`${llmKrakendUrl}/loaders`, { params }),
  getLoader: (id: string) => client.get<RagLoader>(`${llmKrakendUrl}/loaders/${id}`),
  createLoader: (loader: RagLoader) => client.post<RagLoader>(`${llmKrakendUrl}/loaders`, loader),
  editLoader: (loader: RagLoader) => client.put<RagLoader>(`${llmKrakendUrl}/loaders/${loader.id}`, loader),
  deleteLoader: (id: number) => client.delete(`${llmKrakendUrl}/loaders/${id}`),
  getLoadersDocumentation: () => client.get<MetaLoaderListDTO[]>(`${llmKrakendUrl}/loaders/documentation`),
  getLoaderChunks: (body: LoaderChunksRequestBody) => client.post<ChunkMetadata>(`${llmKrakendUrl}/loaders/chunk`, body),
  getLoaderDocumentation: (id: string) => client.get<LoaderMetadata>(`${llmKrakendUrl}/loaders/${id}/documentation`),
  testLoader: (loader: LoaderTestInfo) => client.post<TestLoaderResponse>(`${llmKrakendUrl}/loaders/test`, loader)
}